<template lang="pug">
ul.list-group
  li.list-group-item
    label
      input(type="radio" :value="NOW" v-model="whenChoice" name="publish-when")
      |
      | Publish now
  li.list-group-item
    label
      input(type="radio" :value="CUSTOM" v-model="whenChoice" name="publish-when")
      |
      | Publish at
    span
      select(v-model="publishAtMonth" :disabled="dateDisabled")
        option(v-for="(month, index) in months" :value="index + 1") {{ month }}
      select(v-model="publishAtDay" :disabled="dateDisabled")
        option(v-for="day in days" :value="day") {{ day }}
      select(v-model="publishAtYear" :disabled="dateDisabled")
        option(v-for="year in years" :value="year") {{ year }}
      | —
      select(v-model="publishAtHour" :disabled="dateDisabled")
        option(v-for="hour in hours" :value="hour") {{ hourLabel(hour) }}
      | :
      select(v-model="publishAtMinute" :disabled="dateDisabled")
        option(v-for="fiveMinuteCount in 12" :value="fiveMinuteCountToMinutes(fiveMinuteCount)")
          | {{ minuteLabel(fiveMinuteCountToMinutes(fiveMinuteCount)) }}
  li.list-group-item
    label
      input.do-not-publish(type="radio" :value="DONT" v-model="whenChoice" name="publish-when")
      |
      | Do not publish
</template>

<script>
  // TODO: it would be good if this could use the standard DateField component

  // TODO: we should get rid of this moment dependency as I believe it's our only remaining use of it
  // and it's somewhat deprecated.
  var moment = require('moment');

  // Constants for publish date options to prevent typos
  const NOW = 'now';
  const CUSTOM = 'custom';
  const DONT = 'dont';

  module.exports = {
    props: {
      now: {
        type: Object,
        default() { return moment() }
      },
      years: {
        type: Array,
        default() {
          const thisYear = new Date().getFullYear();
          return _.range(thisYear, thisYear + 3);
        }
      },
      modelValue: {
        type: Date,
        default() { return new Date() }
      },
      when: {
        type: String,
        default() { return DONT }
      }
    },

    data() {
      return {
        NOW,
        CUSTOM,
        DONT,
        publishAtMonth: this.modelValue.getMonth() + 1,
        publishAtDay: this.modelValue.getDate(),
        publishAtYear: this.modelValue.getFullYear(),
        publishAtHour: this.modelValue.getHours(),
        // Next 5 minute block
        publishAtMinute: this.currentFiveMinutes(),
        months: moment.months(),
        days: _.range(1, 32),
        hours: _.range(24)
      };
    },

    computed: {
      whenChoice: {
        get() {
          return this.when
        },
        set(val) {
          this.$emit('whenInput', val)
        }
      },

      dateDisabled() {
        this.when !== CUSTOM
      },

      selectedTime() {
        if(this.when === NOW) {
          return this.now.toDate();
        } else if(this.when === CUSTOM) {
          return new Date(
            this.publishAtYear,
            this.publishAtMonth - 1,
            this.publishAtDay,
            this.publishAtHour,
            this.publishAtMinute
          );
        } else {
          return null;
        }
      }
    },

    watch: {
      modelValue(val) {
        if(!val) return null;

        this.publishAtMonth = val.getMonth() + 1
        this.publishAtDay = val.getDate()
        this.publishAtYear = val.getFullYear()
        this.publishAtHour = val.getHours()
        // Next 5 minute block
        this.publishAtMinute = this.currentFiveMinutes()
      },

      selectedTime() {
        // For component v-model support
        this.$emit('update:modelValue', this.selectedTime)
      }
    },

    methods: {
      currentFiveMinutes() {
        var fiveMinutes = Math.ceil(this.modelValue.getMinutes() / 5) * 5;

        if(fiveMinutes == 60) { return 0; } else { return fiveMinutes; }
      },

      hourLabel(hour) {
        return moment().hour(hour).format('h A');
      },

      minuteLabel(minute) {
        // Zero pad
        return ('00' + minute).substr(-2, 2);
      },

      fiveMinuteCountToMinutes(fiveMinuteCount) {
        return (fiveMinuteCount - 1) * 5;
      }
    }
  }
</script>
